(function () {
  'use strict';
  var bar = document.getElementById('rm-ann-bar');
  var textEl = document.getElementById('rm-ann-bar-text');
  if (!bar || !textEl) return;

  var interval = parseInt(bar.getAttribute('data-interval') || '4', 10) * 1000;
  // Bericht 3 is het deal-bericht: de tekst komt uit de thema-instellingen,
  // de countdown (tot middernacht) wordt erachter gezet.
  var msgs = [1, 2, 3, 4].map(function (n) {
    return { text: bar.getAttribute('data-msg-' + n), countdown: n === 3 };
  }).filter(function (m) { return m.text; });

  if (!msgs.length) return;

  var idx = 0;

  function pad(n) { return String(n).padStart(2, '0'); }

  function countdownStr() {
    var end = new Date();
    end.setHours(23, 59, 59, 999);
    var diff = Math.max(0, Math.floor((end.getTime() - Date.now()) / 1000));
    return pad(Math.floor(diff / 3600)) + ':' + pad(Math.floor((diff % 3600) / 60)) + ':' + pad(diff % 60);
  }

  function textFor(m) {
    return m.countdown ? m.text + ' ' + countdownStr() : m.text;
  }

  function render() {
    textEl.textContent = textFor(msgs[idx % msgs.length]);
    textEl.style.animation = 'none';
    void textEl.offsetWidth;
    textEl.style.animation = 'rmBarFade 0.5s ease';
    idx++;
  }

  render();
  setInterval(render, interval);
  setInterval(function () {
    var m = msgs[(idx - 1 + msgs.length) % msgs.length];
    if (m.countdown) textEl.textContent = textFor(m);
  }, 1000);
})();
